import { createFileRoute } from "@tanstack/react-router";
import { IntegracoesPage } from "@/components/pages/IntegracoesPage";

const SITE = "https://kentro.com.br";

const META = {
  en: {
    title: "Kentro Integrations: API, Webhooks & +30 Tools",
    desc: "Connect Kentro to your ERP, CRM and favorite tools via REST API and Webhooks. See all integrations: IXCSoft, RD Station, HubSpot, Shopify and more.",
    ogTitle: "Kentro Integrations: API, Webhooks & +30 Tools",
    ogDesc: "Integrate Kentro into your ecosystem via REST API and Webhooks.",
  },
  es: {
    title: "Integraciones Kentro: API, Webhooks y +30 herramientas",
    desc: "Conecta Kentro a tu ERP, CRM y herramientas favoritas vía API REST y Webhooks. Ve todas las integraciones: IXCSoft, RD Station, HubSpot, Shopify y más.",
    ogTitle: "Integraciones Kentro: API, Webhooks y +30 herramientas",
    ogDesc: "Integra Kentro a tu ecosistema vía API REST y Webhooks.",
  },
} as const;

export const Route = createFileRoute("/$locale/integracoes")({
  head: ({ params }) => {
    const loc: "en" | "es" = params.locale === "es" ? "es" : "en";
    const m = META[loc];
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { property: "og:title", content: m.ogTitle },
        { property: "og:description", content: m.ogDesc },
        { property: "og:url", content: `${SITE}/${loc}/integracoes` },
        { property: "og:locale", content: loc === "es" ? "es_ES" : "en_US" },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/integracoes` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/integracoes` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/integracoes` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/integracoes` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/integracoes` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: loc === "es" ? "Inicio" : "Home", item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: 'Integrações', item: `${SITE}/${loc}/integracoes` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": 'WebPage',
            "@id": `${SITE}/${loc}/integracoes`,
            url: `${SITE}/${loc}/integracoes`,
            name: m.title,
            description: m.desc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: IntegracoesPage,
});
